import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-create-cupping-session',
  imports: [RmsModule],
  templateUrl: './create-cupping-session.component.html',
  styleUrl: './create-cupping-session.component.scss'
})
export class CreateCuppingSessionComponent {
  CuppingSession: any = {};

  constructor(private pulldownRef: RmsPulldownRef, @Inject(RMS_PULLDOWN_DATA) public data: any) {
    this.CuppingSession = this.data || {};
  }

  save() {
    if (this.CuppingSession.NumberOfTables > 3) {
      window.alert('Number of tables cannot exceed 3.')
      return
    }
    this.pulldownRef.close({ ...this.CuppingSession, cancelled: false });
  }
  cancel() {
    this.pulldownRef.close({ cancelled: true });
  }
}
